<script>
    import {onMount} from "svelte";
    import {querystring} from "svelte-spa-router";
    import {API_URL} from "../../../../env";
    import {calculateProgressBar, checkPassword} from "../../../js/calculatePasswordStrength";
    import {showDialogLogin} from "../../../js/stores";
    import {addAlert} from "../../../js/alert";

    let form = {
        token: null,
        newPassword: "",
        repeatNewPassword: ""
    }
    let bad = {
        newPassword: false,
        repeatNewPassword: false,
    }

    let errorReason = ""


    onMount(() => {
        const urlParams = new URLSearchParams($querystring)

        if (!urlParams.has("t")) {
            return showDialogLogin.set({show: true, type: "error", data: {title: "Vyskytla sa chyba", text: "Nie je možné zmeniť žiadne zabudnuté heslo, chýba overovací token."}})
        }

        form.token = urlParams.get("t")

        if (form.token.length === 0) {
            return showDialogLogin.set({show: true, type: "error", data: {title: "Vyskytla sa chyba", text: "Nie je možné zmeniť žiadne zabudnuté heslo, chýba overovací token."}})
        }
    })

    let passwordStrength = {
        text: "",
        progressBar: 0,
        progressBarColor: "#888888"
    }

    let isFetching = false
    async function handleChange() {
        if (isFetching) return;
        isFetching = true

        /* Check form */
        let isBad = false
        bad = {
            newPassword: false,
            repeatNewPassword: false
        }

        if (form.repeatNewPassword.length < 8 && form.newPassword !== form.repeatNewPassword) {
            errorReason = "Heslá sa nezhodujú."
            bad.newPassword = true
            isBad = true
        }
        if (form.newPassword.length < 8) { //&& form.newPassword.length > 64
            bad.newPassword = true
            errorReason = "Heslo je príliš krátke."
            isBad = true
        }

        if (isBad) {
            return isFetching = false;
        }
        /* ********** */

        let body = {...form}

        delete body.repeatNewPassword

        const res = await fetch(API_URL+'/users/changeForgottenPassword', {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            addAlert("danger", "Chyba", "Chyba pri obnove hesla, skúste to prosím znova.")
            isFetching = false
            return;
        }

        showDialogLogin.set({show: true, type: "check", data: {title: "Heslo bolo zmenené", text: 'Teraz sa môžete s novým heslom <a data-modal="login">prihlásiť.</a>'}})
    }

    function handlePasswordStrength(e) {
        passwordStrength = checkPassword(e.target.value)
        passwordStrength.progressBar = calculateProgressBar(passwordStrength.strength)
    }
</script>

<div class="dc-title mb-4">Obnovenie zabudnutého hesla</div>

<div class="input-group mb-2">
    <label for="newPassword" on:input={handlePasswordStrength}>Heslo</label>
    <input class:unfilled={bad.newPassword} id="newPassword" name="newPassword" type="password" placeholder="Heslo" bind:value={form.newPassword} on:input={handlePasswordStrength}>
</div>

<div class="input-group mb-2">
    <label for="repeatNewPassword">Heslo znova</label>
    <input class:unfilled={bad.newPassword} id="repeatNewPassword" name="repeatNewPassword" type="password" placeholder="Heslo znova" bind:value={form.repeatNewPassword}>
</div>

<div class="input-group mb-2">
    <label>Síla hesla</label>
    <div class="strength-bar" style="--progress-width: {passwordStrength.progressBar.progress}%; --progress-hex: {passwordStrength.progressBar.color};"></div>
</div>

<p class="text-danger text-right">{errorReason}</p>

<div class="d-flex justify-content-center mt-4">
    <button class="btn btn-slate-50" on:click={handleChange}>
        {#if isFetching}
            <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
        {:else}
            <i class="fas fa-fw fa-check mr-2"></i>
        {/if}
        Zmeniť heslo
    </button>
</div>

<style>
    .dc-title {
        font-size: 1.5rem;
        font-weight: 600;
    }
</style>